module.exports = __webpack_public_path__ + "static/media/btn3.83cef2fe.svg";